<template>
  <el-dialog
    :title="title"
    :close-on-click-modal="false"
    :visible.sync="visible"
    append-to-body
    class="staff-dialog"
    width="640px"
  >
    <el-form :model="dataForm" :rules="dataRule" :disabled="isView" ref="dataForm" inline label-position="top">
      <!-- 名 -->
      <el-form-item :label="$t('1048')" prop="first_name">
        <el-input :placeholder="$t('323')" v-model="dataForm.first_name" class="input-with-select">
          <el-select
            class="short-select"
            slot="prepend"
            v-model="dataForm.call_type"
            :placeholder="isView ? '' : $t('1047')"
            filterable
            @change="handlerChangeCallType"
          >
            <el-option v-for="(item, index) in callTypeListDefault" :key="index" :label="item.txt" :value="item.code">
            </el-option>
          </el-select>
        </el-input>
      </el-form-item>
      <!-- 姓 -->
      <el-form-item prop="last_name">
        <template slot="label">
          <el-tooltip effect="dark" :content="$t('1809')" placement="top">
            <span>{{ $t('1049') }} <i class="el-icon-warning-outline" /></span>
          </el-tooltip>
        </template>
        <el-input v-model="dataForm.last_name" :placeholder="isView ? '' : $t('1049')"></el-input>
      </el-form-item>

      <!-- 英文名 -->
      <el-form-item :label="$t('name_en')" prop="first_name_en">
        <el-input :placeholder="$t('323')" v-model="dataForm.first_name_en" class="input-with-select">
          <el-select
            class="short-select"
            slot="prepend"
            v-model="dataForm.call_type_en"
            :placeholder="isView ? '' : $t('1047')"
            filterable
          >
            <el-option v-for="(item, index) in callTypeListEn" :key="index" :label="item.txt" :value="item.code">
            </el-option>
          </el-select>
        </el-input>
      </el-form-item>
      <!-- 英文姓 -->
      <el-form-item>
        <template slot="label">
          <el-tooltip effect="dark" :content="$t('1809')" placement="top">
            <span>{{ $t('1858') }} <i class="el-icon-warning-outline" /></span>
          </el-tooltip>
        </template>
        <el-input v-model="dataForm.last_name_en" :placeholder="isView ? '' : $t('1049')"></el-input>
      </el-form-item>

      <el-form-item prop="mobile">
        <template slot="label">
          <!-- 员工是否注册了账号0否1是 -->
          <!-- 1765 手机号属于员工个人信息，请通过此员工Flash HR APP【我的】-【账号管理】-【绑定手机号】更换手机号 -->
          <!-- 修改 -->
          <el-tooltip
            v-if="Boolean(dataForm.staff_id)"
            effect="dark"
            :content="dataForm.is_register_user === '0' ? $t('1766') : $t('1765')"
            placement="top"
          >
            <span>{{ $t('23') }} <i class="el-icon-warning-outline" /></span>
          </el-tooltip>
          <!-- 新增 -->
          <el-tooltip v-else effect="dark" :content="$t('1766')" placement="top">
            <span>{{ $t('23') }} <i class="el-icon-warning-outline" /></span>
          </el-tooltip>
        </template>
        <el-input
          v-model="dataForm.mobile"
          :placeholder="isView ? '' : $t('90')"
          :disabled="!Boolean(dataForm.is_register_user === '0') && Boolean(dataForm.staff_id)"
        >
          <el-select
            v-model="dataForm.mobile_country_code"
            slot="prepend"
            :placeholder="$t('221')"
            class="short-select"
            :disabled="!Boolean(dataForm.is_register_user === '0') && Boolean(dataForm.staff_id)"
          >
            <el-option label="+66" value="66"></el-option>
            <el-option label="+62" value="62"></el-option>
          </el-select>
        </el-input>
      </el-form-item>
      <el-form-item :label="$t('27')" prop="department_id">
        <el-popover
          v-model="popover"
          width="100%"
          :disabled="isView"
          ref="treePopover"
          placement="bottom"
          trigger="click"
        >
          <dep-tree v-if="popover" @node-click="handleNodeClick"></dep-tree>
        </el-popover>
        <el-input
          v-model="dataForm.department_name"
          v-popover:treePopover
          :placeholder="isView ? '' : $t('19')"
          clearable
          @clear="departmentClear"
        ></el-input>
      </el-form-item>
      <el-form-item :label="$t('24')" prop="job_title_id">
        <el-select
          v-model="dataForm.job_title_id"
          filterable
          remote
          reserve-keyword
          clearable
          :placeholder="isView ? '' : $t('90')"
          :remote-method="positionRemoteMethod"
          :no-data-text="$t('789')"
        >
          <el-option v-for="item in positionOptions" :key="item.id" :label="item.job_title_name" :value="item.id">
          </el-option>
        </el-select>
      </el-form-item>
      <!-- 员工状态 -->
      <el-form-item :label="$t('31')" prop="state">
        <el-select
          v-model="dataForm.state"
          :placeholder="isView ? '' : $t('221')"
          @change="handleState"
          :disabled="['2', '3'].includes(dataForm.state)"
        >
          <el-option
            v-for="(item, index) in sysInfoArr.state"
            :key="index"
            :label="item.value"
            :value="item.key"
            :disabled="['1', '4'].includes(dataForm.state) && ['2', '3'].includes(item.key)"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <!-- 选择入职时间 -->
      <el-form-item :label="$t('28')" prop="hire_date">
        <el-date-picker
          type="date"
          v-model="dataForm.hire_date"
          value-format="yyyy-MM-dd"
          :placeholder="isView ? '' : $t('790')"
          @change="onHireDate"
        >
        </el-date-picker>
      </el-form-item>
      <!-- 选择离职时间 -->
      <el-form-item :label="$t('29')" prop="leave_date" key="leave_date1">
        <template slot="label">
          {{ $t('29') }}
          <el-tooltip class="item" effect="dark" :content="$t('i18n.7Y1RdNWcszSG')" placement="top-start">
            <i class="el-icon-warning-outline"></i>
          </el-tooltip>
        </template>
        <el-date-picker
          disabled
          type="date"
          v-model="dataForm.leave_date"
          value-format="yyyy-MM-dd"
          :picker-options="pickerOptions"
        >
        </el-date-picker>
      </el-form-item>
      <!-- 停职日期 -->
      <el-form-item :label="$t('1820')" key="stop_duties_date" prop="stop_duties_date">
        <el-date-picker
          type="date"
          :disabled="dataForm.state !== '4'"
          v-model="dataForm.stop_duties_date"
          value-format="yyyy-MM-dd"
          :placeholder="isView ? '' : $t('1820')"
          :picker-options="pickerOptions"
        >
        </el-date-picker>
      </el-form-item>
      <!-- 员工属性 -->
      <el-form-item :label="$t('32')" prop="formal">
        <el-select v-model="dataForm.formal" clearable :placeholder="isView ? '' : $t('221')">
          <el-option v-for="(item, index) in sysInfoArr.formal" :key="index" :label="item.value" :value="item.key">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item :label="$t('980')" prop="manager_id">
        <el-select
          v-model="dataForm.manager_id"
          filterable
          remote
          reserve-keyword
          clearable
          :placeholder="isView ? '' : $t('90')"
          :remote-method="supRemoteMethod"
          :loading="supLoading"
        >
          <el-option v-for="item in supOptions" :key="item.staff_id" :label="item.staff_name" :value="item.staff_id">
          </el-option>
        </el-select>
      </el-form-item>
      <!-- 试用期(天) -->
      <el-form-item :label="$t('invite_7')">
        <el-input
          v-model.number="dataForm.probation_day"
          @input="dataForm.probation_day = String(dataForm.probation_day).replace(/[^\d]/g, '')"
          @blur="onProbationDay(dataForm.probation_day)"
          :placeholder="$t('90')"
          clearable
          :disabled="['edit'].includes(operateType)"
        />
      </el-form-item>
      <!-- 转正日期 -->
      <el-form-item prop="formal_date">
        <template slot="label">
          <el-tooltip class="item" effect="dark" :content="$t('invite_8')" placement="top-start">
            <span>{{ $t('30') }} <i class="el-icon-warning-outline" /></span>
          </el-tooltip>
        </template>
        <el-date-picker
          v-model="dataForm.formal_date"
          value-format="yyyy-MM-dd"
          type="date"
          :picker-options="pickerOptions"
          :placeholder="isView ? '' : $t('792')"
          :disabled="['edit'].includes(operateType)"
        >
        </el-date-picker>
      </el-form-item>
      <!-- 工号 -->
      <el-form-item :label="$t('25')" prop="staff_code">
        <el-input v-model="dataForm.staff_code" :placeholder="isView ? '' : $t('90')"></el-input>
      </el-form-item>
      <!-- 工作地点 -->
      <el-form-item :label="$t('1020')" prop="staff_code">
        <el-input v-model="dataForm.work_address" :placeholder="isView ? '' : $t('90')"></el-input>
      </el-form-item>
      <!-- 个人邮箱 -->
      <el-form-item :label="$t('personal_email')" prop="personal_email">
        <el-input v-model="dataForm.personal_email" :placeholder="isView ? '' : $t('90')"></el-input>
      </el-form-item>
      <!-- 企业邮箱 -->
      <el-form-item :label="$t('business_mailbox')" prop="personal_email">
        <el-input v-model="dataForm.enterprise_email" :placeholder="isView ? '' : $t('90')"></el-input>
      </el-form-item>
      <!-- line id -->
      <el-form-item label="LINE ID" prop="personal_email">
        <el-input v-model="dataForm.line_id" :placeholder="isView ? '' : $t('90')"></el-input>
      </el-form-item>
      <!-- 性别 -->
      <el-form-item :label="$t('1050')">
        <el-select v-model="dataForm.sex" :placeholder="isView ? '' : $t('1050')">
          <el-option v-for="(item, index) in sexList" :key="`${index}b`" :label="item.txt" :value="item.code">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item :label="$t('1051')">
        <el-select v-model="dataForm.nationality" :placeholder="isView ? '' : $t('258')" @change="changeIdCardNo">
          <el-option v-for="(item, key) in countriesList" :key="`${key}a`" :label="item" :value="key"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item :label="$t('1052')">
        <el-date-picker
          v-model="dataForm.birth_date"
          type="date"
          value-format="yyyy-MM-dd"
          :placeholder="isView ? '' : $t('1107')"
          :picker-options="{ disabledDate }"
        >
        </el-date-picker>
      </el-form-item>
      <el-form-item :label="$t('1053')" prop="id_card_no">
        <el-input v-model="dataForm.id_card_no" :placeholder="isView ? '' : $t('1053')"></el-input>
      </el-form-item>
      <el-form-item :label="$t('33')" prop="settlement_type">
        <el-select v-model="dataForm.settlement_type" clearable :placeholder="isView ? '' : $t('221')">
          <el-option
            v-for="(item, index) in sysInfoArr.settlement_type"
            :key="index"
            :label="item.value"
            :value="item.key"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item :label="$t('34')" prop="salary_method">
        <el-select v-model="dataForm.salary_method" clearable :placeholder="isView ? '' : $t('797')">
          <el-option
            v-for="(item, index) in sysInfoArr.salary_method"
            :key="index"
            :label="item.value"
            :value="item.key"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <!-- 备注 -->
      <el-form-item :label="$t('1602')">
        <el-input v-model="dataForm.remark" :placeholder="$t('1602')"></el-input>
      </el-form-item>
      <el-form-item></el-form-item>
      <el-form-item style="width: 100%">
        <span slot="label">
          <span>
            <span>{{$t('1054')}}</span>
            <el-tooltip effect="dark" :content="$t('15556_78bb7bd0')" placement="top">
              <i class="el-icon-warning-outline"></i>
            </el-tooltip>
          </span>
        </span>
        <el-col>
          <el-form-item class="country-item" :label="$t('15366_22fe9dc8')">
            <el-select v-model="dataForm.address.country" :placeholder="$t('221')" class="address-select">
              <el-option
                v-for="v in register_country_list"
                :value="v.code"
                :key="v.id"
                :label="v.name"
              ></el-option>
            </el-select>
          </el-form-item>
          <span v-if="dataForm.address.country === 'TH'">
            <!-- 省 -->
            <el-form-item class="country-item" :label="$t('15366_c22fe9dc')">
              <el-input
                v-model="dataForm.address.province"
                :placeholder="isView ? '' : $t('15366_c22fe9dc')"
              ></el-input>
            </el-form-item>
            <el-form-item class="country-item" :label="$t('15366_8ff2c22f')">
              <el-input v-model="dataForm.address.city" :placeholder="isView ? '' : $t('15366_8ff2c22f')"></el-input>
            </el-form-item>
            <el-form-item class="country-item" :label="$t('15366_ff2c22fe')">
              <el-input
                v-model="dataForm.address.district"
                :placeholder="isView ? '' : $t('15366_ff2c22fe')"
              ></el-input>
            </el-form-item>
            <el-form-item class="country-item" :label="$t('1042')">
              <el-input v-model="dataForm.address.postal_code" :placeholder="isView ? '' : $t('1042')"></el-input>
            </el-form-item>
          </span>
          <el-form-item v-else label=" ">
            <el-input v-model="dataForm.address.formated_address" :placeholder="isView ? '' : $t('1054')"></el-input>
          </el-form-item>
        </el-col>
        <el-col v-if="dataForm.address.country === 'TH'">
          <el-form-item class="country-item" :label="$t('1245')">
            <el-input v-model="dataForm.address.door_number" :placeholder="isView ? '' : $t('1245')"></el-input>
          </el-form-item>
          <el-form-item class="country-item" :label="$t('15366_village')">
            <el-input v-model="dataForm.address.village_no" :placeholder="isView ? '' : $t('15366_village')"></el-input>
          </el-form-item>
          <el-form-item class="country-item" :label="$t('15366_2c22fe9d')">
            <el-input v-model="dataForm.address.village" :placeholder="isView ? '' : $t('15366_2c22fe9d')"></el-input>
          </el-form-item>
          <el-form-item class="country-item" :label="$t('15366_f2c22fe9')">
            <el-input v-model="dataForm.address.lane" :placeholder="isView ? '' : $t('15366_f2c22fe9')"></el-input>
          </el-form-item>
          <el-form-item class="country-item" :label="$t('15366_road')">
            <el-input v-model="dataForm.address.road" :placeholder="isView ? '' : $t('15366_road')"></el-input>
          </el-form-item>
        </el-col>
      </el-form-item>
    </el-form>
    <template slot="footer">
      <el-button @click="visible = false">{{ $t('66') }}</el-button>
      <el-button
        v-if="['create', 'edit'].includes(operateType)"
        type="primary"
        @click="dataFormSubmit"
        :disabled="disabled"
      >
        {{ $t('131') }}
      </el-button>
    </template>
  </el-dialog>
</template>

<script>
import UpdateProbationRadio from '@/components/probation-status-radio.vue'
import {
  addFn,
  updateFn,
  searchStaffFn,
  getCallTypeUrlMethod,
  getSexUrlMethod,
  getCountries,
} from 'api/org/per'
import { getRegularEnv } from 'api/dashboard'
import { countries } from 'api/login'
import depTree from '@/components/dep-tree'
import { v4 as uuidv4 } from 'uuid'
const dataForm = () => ({
  first_name: '', // 员工姓名
  first_name_en: '', // 员工英文名
  call_type: '', // 称谓
  call_type_en: '', // 英文称谓
  last_name: '', // 姓
  last_name_en: '', // 英文姓
  mobile: '', // 手机号
  department_name: '', // 部门名称
  department_id: '', // 部门id
  job_title_id: '', // 职位id
  hire_date: '', // 入职日期
  leave_date: '', // 离职日期
  state: '1', // 在职状态 员工状态
  formal: '', // 员工属性s
  manager_id: '', // 直线上级id
  formal_date: '', // 转正日期
  staff_code: '', // 员工工号
  personal_email: '', // 个人邮箱
  enterprise_email: '', // 企业邮箱
  line_id: '', // LINR ID
  remark: '', // 备注
  settlement_type: '', // 结算类型
  salary_method: '', // 发薪方式,
  is_register_user: '',
  address: {
    country: 'TH',
    province: '',
    city: '',
    district: '',
    postal_code: '',
    door_number: '',
    village_no: '',
    village: '',
    lane: '',
    road: '',
    formated_address: ''
  },
  birth_date: '',
  call_type_txt: '',
  formal_name: '',
  id: '',
  id_card_no: '',
  job_title_name: '',
  manager_name: '',
  mobile_country_code: '66',
  nationality: '',
  nationality_txt: '',
  settlement_type_name: '',
  sex: '',
  sex_txt: '',
  staff_id: '',
  state_name: '',
  stop_duties_date: null,
  work_address: '',
  formal_state: '1',
  probation_day: '',
  register_country: '1' // 国家
})

export default {
  props: {
    sysInfoArr: {
      type: Object,
      default: () => ({
        state: [], // 在职状态   1-在职 2-离职 3-待离职 4-停职
        salary_method: [], // 发薪方式
        settlement_type: [], // 结算类型
        formal: [] // 员工属性
      })
    },
    posiAllList: {
      type: Array,
      default: () => []
    },
    operateType: {
      type: String,
      default: ''
    }
  },
  components: {
    depTree
  },
  data() {
    const self = this
    return {
      visible: false,
      disabled: false,
      popover: false,
      positionOptions: [],
      supLoading: false,
      supOptions: [],
      dataForm: dataForm(),
      cDataForm: {},
      callTypeListDefault: [], // 当前语言环境称谓
      callTypeListEn: [], // 英文称为
      sexList: [], // 性别列表
      countriesList: {}, // 国籍列表
      dataRule: {
        first_name: [{ required: true, message: this.$t('1256') }],
        last_name: [{ required: true, message: this.$t('1256') }],
        mobile: [{ required: true, message: this.$t('241') }],
        department_id: [{ required: true, message: this.$t('794') }],
        hire_date: [{ required: true, message: this.$t('795') }],
        leave_date: [{ required: true, message: this.$t('795') }],
        stop_duties_date: [{ required: false, message: this.$t('1820') }],
        id_card_no: [{ required: false, message: this.$t('1339') }],
        settlement_type: [{ required: true, message: this.$t('796') }],
        salary_method: [{ required: true, message: this.$t('797') }],
        state: [{ required: true, message: this.$t('799') }],
        formal: [{ required: true, message: this.$t('800') }]
      },
      pickerOptions: {
        disabledDate: time => {
          // 离职日期、转正日期、停职日期在hire_date之后可以选择
          const hire_date = new Date(self.dataForm.hire_date).getTime() - 86400000
          return time.getTime() < hire_date
        }
      },
      register_country_list: []
    }
  },
  computed: {
    isView() {
      return this.operateType === 'view'
    },
    title() {
      if (this.operateType === 'view') return this.$t('64')
      else return this.dataForm.staff_id ? this.$t('13') : this.$t('344')
    }
  },
  methods: {
    init(item) {
      // 获取称谓列表 eslint-disable-next-line
      getCallTypeUrlMethod().then(res => {
        if (res.data) {
          this.callTypeListDefault = res.data.default
          this.callTypeListEn = res.data.en
        }
      })
      // 获取国家列表
      getCountries().then(res => {
        this.register_country_list = res?.data
      })
      // 获取性别列表 eslint-disable-next-line
      getSexUrlMethod().then(res => (this.sexList = res && res.data))
      // 获取国籍列表 eslint-disable-next-line
      countries().then(res => (this.countriesList = res && res.data))
      this.visible = true
      this.$nextTick(async () => {
        this.$refs.dataForm.resetFields()
        this.dataForm = (item && JSON.parse(JSON.stringify({ ...dataForm(), ...item }))) || dataForm()
        // 获取试用期天数
        if (this.operateType === 'create') {
          const res = await getRegularEnv({ code: 'STAFF_PROBATION_DAY' })
          if (res && res.code && !this.dataForm.probation_day) this.dataForm.probation_day = res.data
        }
        this.dataForm.formal_state =
          !this.dataForm.formal_state || this.dataForm.formal_state === '0' ? '1' : this.dataForm.formal_state
        this.$nextTick(() => this.$refs.dataForm.clearValidate())
        const result = item && item.job_title_id && [{ job_title_name: item.job_title_name, id: item.job_title_id }]
        this.positionOptions = result || []
        const lresult = item && item.manager_id && [{ staff_name: item.manager_name, staff_id: item.manager_id }]
        this.supOptions = lresult || []
        this.handleState()
        if (this.operateType === 'edit' && this.dataForm.staff_id) {
          this.dataRule.id_card_no[0].required = item.nationality === 'TH'
        }
        if (this.dataForm.hire_date && this.dataForm.probation_day && !this.dataForm.formal_date) {
          this.handleProbation(this.dataForm.probation_day, this.dataForm.hire_date)
        }
        this.cDataForm = JSON.parse(JSON.stringify(this.dataForm))
      })
    },
    // 泰国 身份证号必填
    changeIdCardNo(item) {
      this.dataRule.id_card_no[0].required = item === 'TH'
    },
    // 称谓同步
    handlerChangeCallType(params) {
      // console.log(params)
      this.dataForm.call_type_en = params
    },
    handleState() {
      if (['1', '4'].includes(this.dataForm.state)) {
        this.dataForm.leave_date = ''
        this.dataRule.leave_date[0].required = false
      } else {
        this.dataRule.leave_date[0].required = true
      }
      const state = this.dataForm.state !== '4'
      if (state) this.dataForm.stop_duties_date = ''
      this.dataRule.stop_duties_date[0].required = !state
    },
    // 出生日期禁选项 必须大于当前日期
    disabledDate(t) {
      return new Date().getTime() < t.getTime()
    },
    handleNodeClick(val) {
      this.dataForm.department_id = val.department_id
      this.dataForm.department_name = val.department_name
      this.popover = false
    },
    onProbationDay(v) {
      // 试用期天数
      if (this.dataForm.hire_date) {
        this.handleProbation(v, this.dataForm.hire_date)
      }
    },
    onHireDate(v) {
      // 入职日期
      if (!v) {
        this.dataForm.formal_date = ''
        return
      }
      this.handleProbation(this.dataForm.probation_day, v)
    },
    handleProbation(v, hire) {
      if (['edit', 'view'].includes(this.operateType)) return
      // 填写了“试用期(天)”，自动计算：转正日期=入职日期+试用期(天)——入职日期为第0天
      if (!String(v)) return
      const day = Number(v)
      const hireData = new Date(hire)
      hireData.setDate(hireData.getDate() + day)
      this.dataForm.formal_date = this.formatDay(hireData)
    },
    // 时间戳转换为日期 2020-09-08
    formatDay(timestamp) {
      var date = new Date(timestamp)
      var YY = date.getFullYear()
      var MM = date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1
      var DD = date.getDate() < 10 ? '0' + date.getDate() : date.getDate()
      return `${YY}-${MM}-${DD}`
    },
    changeDormal(v) {
      // 修改转正日期
      // 当转正日期是今天(含)之前的日期，提交时则提示：转正日期已过，是否确认为「已转正」？
      const newTime = new Date().getTime()
      const selectTime = new Date(v).getTime()
      if (selectTime < newTime && this.dataForm.formal_date && this.operateType === 'create') {
        this.dataForm.formal_state = '1'
        const h = this.$createElement
        let formal_state
        this.$msgbox({
          title: this.$t('229'),
          message: h(UpdateProbationRadio, {
            // see https://github.com/ElemeFE/element/issues/8931
            key: uuidv4(),
            on: {
              change(v) {
                formal_state = v
              }
            }
          }),
          distinguishCancelAndClose: true,
          showCancelButton: true,
          confirmButtonText: this.$t('131'),
          cancelButtonText: this.$t('66'),
          customClass: 'probation-msg-box'
        })
          .then(() => {
            this.dataForm.formal_state = formal_state
            if (formal_state === '1') {
              this.dataForm.formal_date = this.cDataForm.formal_date || this.dataForm.formal_date
            }
            this.ajaxFn()
          })
          .catch(action => {
            // if (action === 'close') return
            // this.dataForm.formal_state = '1'
            // this.dataForm.formal_date = this.cDataForm.formal_date || this.dataForm.formal_date
            // this.ajaxFn()
          })
      } else {
        this.ajaxFn()
      }
    },
    positionRemoteMethod(query) {
      this.positionOptions =
        query !== ''
          ? this.posiAllList.filter(v => v.job_title_name.toLowerCase().indexOf(query.toLowerCase()) > -1)
          : []
    },
    supRemoteMethod(query) {
      if (query !== '') {
        this.supLoading = true
        // ajax请求
        clearTimeout(this.timer)
        this.timer = setTimeout(() => {
          searchStaffFn({
            search_name: query,
            page_size: 20
          }).then(res => {
            this.supLoading = false
            if (res && res.code === 1) {
              this.supOptions = res.data.map(v => ({
                staff_name: v.staff_name,
                staff_id: v.staff_id
              }))
            }
          })
        }, 300)
      } else {
        this.supOptions = []
      }
    },
    dataFormSubmit() {
      this.$refs.dataForm.validate(valid => {
        if (valid) {
          this.changeDormal(this.dataForm.formal_date)
        }
      })
    },
    ajaxFn() {
      this.disabled = true
      const payload = JSON.parse(JSON.stringify(this.dataForm))
      // 编辑的时候不需要传formal_state
      if (this.dataForm.staff_id) {
        delete payload.formal_state
      }
      const api = this.dataForm.staff_id ? updateFn(payload) : addFn(payload)
      api
        .then(res => {
          if (res && res.code === 1) {
            this.visible = false
            this.$message.success(res.message)
            this.dataForm = dataForm()
            this.$emit('refreshTableList')
          }
        })
        .catch(err => {
          if (err.code === 2010) {
            this.visible = false
            this.$emit('refreshTableList')
          }
        })
        .finally(() => (this.disabled = false))
    },
    departmentClear() {
      this.dataForm.department_id = null
    }
  }
}
</script>

<style lang="scss" scoped>
.staff-dialog {
  .short-select {
    width: 80px;
  }
  .address-select {
    width: 110px;
  }
  .country-item {
    width: 106px !important;
    padding-left: 0px !important;
  }
  /deep/.el-tooltip {
    cursor: pointer;
    display: inline-block;
  }
  /deep/.el-form {
    .el-form-item {
      width: 48%;
      padding-left: 10px;
      .el-form-item__label {
        padding: 0 7px 0 0;
        &::before {
          left: -10px;
        }
      }
    }
  }
}
</style>
